import { render } from "./TranslatableField.vue?vue&type=template&id=743ee80e&scoped=true"
import script from "./TranslatableField.vue?vue&type=script&lang=js"
export * from "./TranslatableField.vue?vue&type=script&lang=js"

import "./TranslatableField.vue?vue&type=style&index=0&id=743ee80e&lang=scss&scoped=true"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-743ee80e"],['__file',"TranslatableField.vue"]])

export default __exports__